import VueHeadSlot from './plugins/vue-head-slot'
export default VueHeadSlot